import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-juzhongduiqi",
  "use": "icon-juzhongduiqi-usage",
  "viewBox": "0 0 1047 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1047 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-juzhongduiqi\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 910.336h1047.04V1024H0zM872.96 796.672v-114.176H174.592v114.176h698.368zM0 455.168h1047.04v113.664H0zM174.592 227.328h698.368v113.664H174.592zM0 0h1047.04v113.664H0z\" p-id=\"11024\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol